import { render, staticRenderFns } from "./succession-file-summary.vue?vue&type=template&id=71ee3ec0&"
import script from "./succession-file-summary.vue?vue&type=script&lang=js&"
export * from "./succession-file-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports